<template>
    <div>
        <PageTitle :title=" (teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? 'Experiencias' : 'FAN ZONE') + ' para la temporada ' + lista_abonados.nombre"></PageTitle>
        <FirstBanner></FirstBanner>

        <ListadoEventosImagen
            v-if="events.length > 0" 
            :eventos="events"
        />
    </div>
</template>

<script>
import PageTitle from '@/components/frontend/shared/PageTitle';
import FirstBanner from '@/components/frontend/shared/FirstBanner';
import ListadoEventosImagen from '@/components/frontend/events/listado/ListadoEventosImagen';

export default {
    head: {
        title: function() {
            return {
                inner: 'Experiencias',
                complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
            }
        },
        meta: function() {
            return [
                {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
            ]                
        },
    },
    computed : {
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        footer() {
            return this.$store.getters.getFooter;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        events() {
            let array = [];
            var ahora = moment();
            if(this.$store.getters.getFrontExperiencias.data) {
                this.$store.getters.getFrontExperiencias.data.forEach(evento => {
                    var fecha = moment(evento.fecha_sesion).add(2, 'hours');

                    if(ahora < fecha) {
                        array.push(evento);
                    }
                });
            }
            return array;
        }
    },
    created() {
        if(!this.footer.partidos && this.footer.ocultar_experiencias || !this.footer.activar_experiencias) {
            this.$router.push({ name: 'front.home'});
        }
    },
    components: {
        PageTitle, FirstBanner, ListadoEventosImagen
    }
}
</script>
  